import { gql } from '@apollo/client';

import { FragmentDealer } from '../dealer';
import { FragmentService } from '../services';

export const FragmentGarageVehicle = gql`
  fragment FragmentGarageVehicle on GarageVehicle {
    id
    make
    model
    vin
    firstRegistration
    images {
      url
      id
    }
    dealer {
      ...FragmentDealer
    }
    services {
      ...FragmentService
    }
    body
    color
    bodyType
    displacement
    powerHp
    powerPs
    powerKw
    mileage
    licencePlate
    vehicleEquipment
    vehicleOptions {
      name
      value
    }
    doors
    engine
    fuel
    transmissionSummary
    transmissionType
    transmissionSteps
    wheelDrive
    seats
    trim
    valuation {
      variantId
      trimId
      equipmentIds
    }
    c2cStatus
    c2cAbstractId
    c2cId
    vehicleMinimalPrice
    vehicleMaximalPrice
    vehicleFinalPrice
  }
  ${FragmentDealer}
  ${FragmentService}
`;
